export const truckModeEnum = {
    APPRO: 0,
    EVAC: 1,
    TRANSFER: 2,
    ONSITE: 3,
    POSE: 4,
    ENLEVEMENT: 5,
    ROTATION: 6,
    DOUBLEFRET: 7,
    BACKANDFORTH: 8,
};

export const truckBillingEnum = {
    RIDE: 1,
    DAY: 2,
};

export const truckGroupEnum = {
    TRUCK_8X4: 1,
    SEMIE: 2,
    AMPLIROLL: 3,
};

export const truckPriceTypeEnum = {
    UNIT: 1,
    DAY: 2,
};

export const truckRenterPriceTypeEnum = {
    UNIT: 1,
    DAY: 2,
    TON: 3,
};
